import React from 'react';

import TextField from '@components/Form/TextField';

const BasicInfoForm = ({ loginLinkOnly }: { loginLinkOnly: boolean }) => {
  return (
    <>
      <TextField className="mb-24" name="name" placeholder="Name" />
      <TextField className="mb-24" name="email" placeholder="email" />
      {!loginLinkOnly && (
        <>
          <TextField
            className="mb-24"
            name="password"
            placeholder="Password (leave blank if you do not wish to change)"
            type="password"
          />
          <TextField
            className="mb-24"
            name="passwordConfirmation"
            placeholder="Confirm Password"
            type="password"
          />
        </>
      )}
    </>
  );
};

export default BasicInfoForm;
